import { Component, OnInit, OnDestroy, ViewChild, ElementRef, DoCheck, AfterViewInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SidenavService } from 'src/app/services/sidenav.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { Subscription } from 'rxjs';
import { NgbModal, ModalDismissReasons, NgbCalendar, NgbDate, NgbDateAdapter, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { Dimensions, ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { DomSanitizer } from '@angular/platform-browser';
import { Foodcourt } from 'src/app/model/foodcourt.model';
import { AddfoodmenuService } from 'src/app/services/addfoodmenu.service';
import { FoodcourtmenuService } from 'src/app/services/foodcourtmenu.service';
import { DateService } from 'src/app/services/date.service';
import { CommonService } from 'src/app/services/common.service';
import { RemovemodalmenuComponent } from 'src/app/modal/remove-modal-menu/remove-modal-menu.component';
import { RolebasedactionService } from 'src/app/services/rolebasedaction.service';

@Component({
  standalone: false,
  selector: 'app-food-menu-details',
  templateUrl: './food-menu-details.component.html',
  styleUrls: ['./food-menu-details.component.scss']
})
export class FoodMenuDetailsComponent implements OnInit {

  public foodcourt = new Foodcourt();
  private subscriptions = new Subscription();
  public accordianIcon = '../../../assets/images/icons/chevron_up.svg';

  menuId: any;
  prakList: any = [];
  menuDetails: any;
  fromDetailsPage: any;
  checkedOnlyUsersList: any;
  singleMenuId = [];
  singleMenuDataDelete = [];
  vendorId: any;
  menulogo = 'menulogo';
  foodCourtVendorId: any;
  ratingArray = [];
  ratingArrayOff = [];
  onlyMenuIds = [];
  foodvendorRemove: any;
  foodvendorEdit: any;
  foodvendorCreate: any;
  foodvendorView: any;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private sideNavService: SidenavService,
    private appStateSrv: AppStateProvider,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private acroute: ActivatedRoute,
    private dateAdapter: NgbDateAdapter<string>,
    private dateSrv: DateService,
    private addfoodmenuService: AddfoodmenuService,
    private foodcourtmenuService: FoodcourtmenuService,
    private commonService: CommonService,
    private route: ActivatedRoute,
    private rolebasedactionService: RolebasedactionService,
  ) {
    localStorage.setItem('expandNavFoodCourt', 'true');
    const routeLink = this.sideNavService.routingChunks({
      name: 'Food Court Management',
      subNav: '1',
      subNavLink: '',
    });
    this.appStateSrv.setSideNavState(routeLink);
  }

  ngOnInit(): void {
    this.foodvendorRemove = this.rolebasedactionService.checkUserRolePermissionExits('Food Court:Remove');
    this.foodvendorEdit = this.rolebasedactionService.checkUserRolePermissionExits('Food Court:Edit');
    this.foodvendorCreate = this.rolebasedactionService.checkUserRolePermissionExits('Food Court:Create');
    this.foodvendorView = this.rolebasedactionService.checkUserRolePermissionExits('Food Court:View');
    this.route.params.subscribe((params) => {
      this.menuId = params['id'];
    });

    this.vendorId = localStorage.getItem('vendor_id');

    localStorage.removeItem('expandNav');
    localStorage.removeItem('expandNavLand');
    localStorage.removeItem('expandNavCreateview');

    this.getMenuDetails();
  }

  ngOnDestroy() {
    localStorage.removeItem('expandNavCreateview');
    this.subscriptions.unsubscribe();
  }

  getParkDetails() {
    this.foodcourtmenuService.getParkByCLAId().subscribe((res) => {
      if (res.isValid) {
        this.prakList = res.list;
      }
    });
  }

  openModal(onlyMenuIds: string): void {

    this.singleMenuDataDelete = [];
    this.onlyMenuIds = [];

    this.singleMenuDataDelete.push({
      "foodCourtVendorMenuIds": [this.menuId],
    });

    // this.onlyMenuIds.push(this.menuId);

    const modalOptions: NgbModalOptions = {
      size: 'md',
    };

    const modalRef = this.modalService.open(RemovemodalmenuComponent, modalOptions);
    // modalRef.componentInstance.menuId = this.singleMenuDataDelete[0];
    modalRef.componentInstance.menuId = [this.menuId];
    modalRef.componentInstance.fromDetailsPage = 'yes';
  }

  getMenuDetails() {
    this.ratingArray = [];
    this.ratingArrayOff = [];
    this.foodcourtmenuService.foodMenuDetails(this.menuId).subscribe((res) => {
      if (res?.isValid === true) {
        this.menuDetails = res;
        this.foodCourtVendorId = this.menuDetails?.data.foodCourtVendorId;
        for (let i = 0; i <= this.menuDetails?.data.rating - 1; i++) {
          this.ratingArray.push({
            ratingCount: i + 1,
            starImage: '../../../assets/images/rating-star-single.png',
            starImageOff: '../../../assets/images/rating-star-single-grey.png',
          });
        }
        for (let j = 0; j <= 5 - this.menuDetails?.data.rating - 1; j++) {
          this.ratingArrayOff.push({
            ratingCount: j + 1,
            starImage: '../../../assets/images/rating-star-single.png',
            starImageOff: '../../../assets/images/rating-star-single-grey.png',
          });
        }
        this.checkedOnlyUsersList = [];
        this.checkedOnlyUsersList.push(this.menuDetails.data);
        console.log(this.checkedOnlyUsersList);
      }
    });
  }

  goToEditPage(id) {
    this.router.navigate(['/update-food-menu/' + id]);
  }

}
